'use client';

import React from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useAgentContext } from '../../context/AgentContext';

export default function NewChatButton() {
  const { clearConversation, toggleHistory } = useAgentContext();

  const handleClick = () => {
    clearConversation();
    toggleHistory();
  };

  return (
    <Button
      onClick={handleClick}
      startIcon={<AddIcon />}
      fullWidth
      sx={{
        color: 'var(--primary-color)',
        borderColor: 'var(--primary-color)',
        borderRadius: '20px',
        textTransform: 'capitalize',
        fontSize: '0.8rem',
        py: '0.375rem',
        '&:hover': {
          borderColor: 'var(--primary-color)',
          bgcolor: 'rgba(71, 225, 188, 0.08)',
        },
      }}
      variant="outlined"
    >
      New conversation
    </Button>
  );
}
